module.exports = __webpack_public_path__ + "img/4.f05612dc.jpg";